import { ICoordinationDetailsRow } from "@veritas-dumpsters/models/coordination-details-row";

export enum DetailRowId {
  coordination = 'coordination',
  address = 'address',
  lastEdit = 'lastEdit' 
}

export const DETAILS_ROW: ICoordinationDetailsRow[] = [
  {
    id: DetailRowId.coordination,
    text: '$lbl.coordinate',
    value: null,
    valueSitGis: null,
    order: 0,
  },
  {
    id: DetailRowId.address,
    text: 'vocabulary.Ticket.Address',
    value: null,
    valueSitGis: null,
    order: 1,
  },
  {
    id: DetailRowId.lastEdit,
    text: 'common.Auditing.Edit',
    value: null,
    valueSitGis: null,
    order: 2,
  }
]
